import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_create_vendor_lots_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { vendor_lots: $frontendTypes.FootprintApiManager.input_create_vendor_lot[] }): Promise<{ vendor_lots?: $frontendTypes.FootprintApiManager.public_vendor_lot[], errors?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.vendor_lots)) {
      $missingRequiredInParams.push('\'vendor_lots\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

